import React from 'react';
import { zoneClass } from '../utils/forensicDisplay';
import ForensicPlainLanguageBlock from './ForensicPlainLanguageBlock';

const zoneFromLabel = (label) => {
    const value = (label || '').toLowerCase();
    if (value === 'clean' || value === 'safe' || value === 'strong') return 'green';
    if (value === 'red flag' || value === 'distress' || value === 'manipulator' || value === 'high concern') {
        return 'red';
    }
    if (!label) return 'neutral';
    return 'yellow';
};

export default function ForensicSynthesisBanner({ analysis, loading, error }) {
    if (loading) {
        return (
            <section className="forensic-banner forensic-zone--neutral" data-axis="synthesis">
                <div className="forensic-banner__eyebrow">Forensic agent synthesis</div>
                <p className="forensic-banner__summary">Reading the scored flags…</p>
            </section>
        );
    }
    if (error) {
        return (
            <section className="forensic-banner forensic-zone--neutral" data-axis="synthesis">
                <div className="forensic-banner__eyebrow">Forensic agent synthesis</div>
                <p className="forensic-banner__summary">{error}</p>
            </section>
        );
    }
    const plain = analysis?.plain_language || analysis?.plainLanguage;
    const technical = analysis?.aggregate_verdict || analysis?.summary;
    if (!plain && !technical) return null;
    const label = analysis?.verdict || 'Watch';
    const confidence = analysis?.confidence;

    return (
        <section className={`forensic-banner ${zoneClass(zoneFromLabel(label))}`} data-axis="synthesis">
            <div className="forensic-banner__eyebrow">Forensic agent synthesis</div>
            <div className="forensic-banner__row">
                <span className="forensic-banner__label">{label}</span>
            </div>
            <ForensicPlainLanguageBlock plain={plain} technical={technical} />
            {confidence && (
                <p className="forensic-banner__confidence">Confidence: {confidence}</p>
            )}
        </section>
    );
}
